import React, { useEffect } from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import { services } from '../data/mock';
import { Check, Clock, Repeat, ArrowLeft } from 'lucide-react';

const ServiceDetail = () => {
  const { slug } = useParams();
  const service = services.find((s) => s.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!service) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Helmet>
        <title>{service.title} - Клининговая компания Bell</title>
        <meta name="description" content={service.description} />
      </Helmet>
      <div className="min-h-screen">
        <Header />

        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="container mx-auto px-4">
            <Link
              to="/"
              className="inline-flex items-center space-x-2 text-orange-600 hover:text-orange-700 font-medium mb-8 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>Вернуться на главную</span>
            </Link>

            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
                  {service.title}
                </h1>
                <p className="text-xl text-gray-600 mb-6 leading-relaxed">
                  {service.fullDescription}
                </p>
                <div className="flex items-baseline space-x-2 mb-8">
                  <span className="text-5xl font-bold text-orange-600">
                    {service.priceFrom}
                  </span>
                  <span className="text-2xl text-gray-600">
                    р. {service.priceType && `/ ${service.priceType}`}
                  </span>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-8">
                  <div className="bg-white p-4 rounded-xl border-2 border-orange-100">
                    <Clock className="w-6 h-6 text-orange-600 mb-2" />
                    <div className="text-sm text-gray-600">Продолжительность</div>
                    <div className="font-semibold text-gray-900">{service.duration}</div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border-2 border-orange-100">
                    <Repeat className="w-6 h-6 text-orange-600 mb-2" />
                    <div className="text-sm text-gray-600">Частота</div>
                    <div className="font-semibold text-gray-900">{service.frequency}</div>
                  </div>
                </div>
              </div>

              <div>
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full rounded-2xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </section>

        {/* What's Included Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
              Что входит в услугу
            </h2>
            <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              {service.includes.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start space-x-3 p-4 rounded-lg hover:bg-orange-50 transition-colors"
                >
                  <div className="flex-shrink-0 w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center mt-0.5">
                    <Check className="w-4 h-4 text-orange-600" />
                  </div>
                  <span className="text-gray-700 leading-relaxed">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <ContactForm />

        <Footer />
      </div>
    </>
  );
};

export default ServiceDetail;